/**
 * =================================================================
 * Drawer Quick Add Product
 * =================================================================
 */

theme.DrawerQuickAddProduct = (function () {
  var classes = {
    onSale: "on-sale",
    disabled: "disabled",
    isModal: "is-modal",
    loading: "loading",
    loaded: "loaded",
    hidden: "hide",
    interactable: "video-interactable",
    visuallyHide: "visually-invisible",
  };

  function DrawerQuickAddProduct(container) {
    var $container = (this.$container = $(container));
    var sectionId = (this.sectionId = $container.attr("data-section-id"));

    this.settings = {
      enableHistoryState: $container.data("enable-history-state") || false,
      namespace: ".product-recommendations-drawer-template .product-" + sectionId,
      inventory: $container.data("inventory") || false,
      incomingInventory: $container.data("incoming-inventory") || false,
      modalInit: false,
      slickMainInitialized: false,
      slickThumbInitialized: false,
      thumbArrows: false,
      thumbVertical: false,
      hasImages: true,
      hasMultipleImages: false,
      has3d: false,
      imageSize: "620x",
      videoLooping: $container.data("video-looping"),
    };

    this.selectors = {
      variantsJson: ".product-recommendations-drawer-template .VariantsJson-" + sectionId,
      currentVariantJson:
        ".product-recommendations-drawer-template CurrentVariantJson-" + sectionId,
      priceWrapper: ".product-recommendations-drawer-template .product__price-wrap-" + sectionId,
      price: ".product-recommendations-drawer-template #ProductPrice-" + sectionId,
      comparePrice: ".product-recommendations-drawer-template #ComparePrice-" + sectionId,
      savePrice: ".product-recommendations-drawer-template #SavePrice-" + sectionId,
      priceA11y: ".product-recommendations-drawer-template #PriceA11y-" + sectionId,
      comparePriceA11y: ".product-recommendations-drawer-template #ComparePriceA11y-" + sectionId,
      unitWrapper:
        ".product-recommendations-drawer-template .product__unit-price-wrapper--" + sectionId,
      unitPrice: ".product-recommendations-drawer-template .product__unit-price--" + sectionId,
      unitPriceBaseUnit:
        ".product-recommendations-drawer-template .product__unit-base--" + sectionId,
      sku: ".product-recommendations-drawer-template #Sku-" + sectionId,
      inventory: ".product-recommendations-drawer-template #ProductInventory-" + sectionId,
      incomingInventory:
        ".product-recommendations-drawer-template #ProductIncomingInventory-" + sectionId,

      addToCart: ".product-recommendations-drawer-template #AddToCart-" + sectionId,
      addToCartText: ".product-recommendations-drawer-template #AddToCartText-" + sectionId,

      originalSelectorId: ".product-recommendations-drawer-template #ProductSelect-" + sectionId,
      singleOptionSelector: ".product-recommendations-drawer-template .variant__input-" + sectionId,
      variantColorSwatch:
        ".product-recommendations-drawer-template .variant__input--color-swatch-" + sectionId,

      modalFormHolder: ".product-recommendations-drawer-template #ProductFormHolder-" + sectionId,
      formContainer: ".product-recommendations-drawer-template #AddToCartForm-" + sectionId,
    };

    this.init();
  }

  DrawerQuickAddProduct.prototype = $.extend({}, DrawerQuickAddProduct.prototype, {
    init: function () {
      this.openModalProduct();
    },

    formSetup: function () {
      // Determine how to handle variant availability selectors
      if (theme.settings.dynamicVariantsEnable) {
        this.$variantSelectors = $(this.selectors.formContainer).find(
          this.selectors.singleOptionSelector
        );
      }

      this.initQtySelector();
      this.initAjaxProductForm();
      this.initVariants();
    },

    addIdToRecentlyViewed: function () {
      var handle = this.$container.attr("data-product-handle");
      var url = this.$container.attr("data-product-url");
      var aspectRatio = this.$container.attr("data-aspect-ratio");
      var featuredImage = this.$container.attr("data-img-url");

      // Remove current product if already in set of recent
      if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
        delete theme.recentlyViewed.recent[handle];
      }

      // Add it back to the end
      theme.recentlyViewed.recent[handle] = {
        url: url,
        aspectRatio: aspectRatio,
        featuredImage: featuredImage,
      };

      if (theme.config.hasLocalStorage) {
        window.localStorage.setItem("theme-recent", JSON.stringify(theme.recentlyViewed.recent));
      }
    },

    stringOverrides: function () {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    initVariants: function () {
      if (!document.getElementById(this.selectors.variantsJson)) {
        return;
      }

      this.variantsObject = JSON.parse(
        document.getElementById(this.selectors.variantsJson).innerHTML
      );

      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        variants: this.variantsObject,
      };

      if ($(this.selectors.variantColorSwatch).length) {
        $(this.selectors.variantColorSwatch).on(
          "change",
          function (evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data("color-name");
            var index = $el.data("color-index");
            this.updateColorName(color, index);
          }.bind(this)
        );
      }

      this.variants = new theme.Variants(options);

      this.$container
        .on("variantChange" + this.settings.namespace, this.updateCartButton.bind(this))
        .on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this))
        .on("variantUnitPriceChange" + this.settings.namespace, this.updateUnitPrice.bind(this));

      if ($(this.selectors.sku).length) {
        this.$container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this));
      }

      if (this.settings.inventory || this.settings.incomingInventory) {
        this.$container.on(
          "variantChange" + this.settings.namespace,
          this.updateInventory.bind(this)
        );
      }

      // Update individual variant availability on each selection
      if (
        theme.settings.dynamicVariantsEnable &&
        document.getElementById(this.selectors.currentVariantJson)
      ) {
        this.currentVariantObject = JSON.parse(
          document.getElementById(this.selectors.currentVariantJson).innerHTML
        );

        this.$variantSelectors.on(
          "change" + this.settings.namespace,
          this.updateVariantAvailability.bind(this)
        );

        // Set default state based on current selected variant
        this.setCurrentVariantAvailability(this.currentVariantObject, true);
      }
    },

    initQtySelector: function () {
      this.$container.find(".js-qty__wrapper").each(function () {
        new theme.QtySelector($(this), {
          namespace: ".product",
        });
      });
    },

    initAjaxProductForm: function () {
      if (theme.settings.cartType === "drawer") {
        new theme.AjaxProduct($(this.selectors.formContainer));
      }
    },

    /*============================================================================
        Dynamic variant availability
          - To disable, set dynamicVariantsEnable to false in theme.liquid
      ==============================================================================*/
    setCurrentVariantAvailability: function (variant) {
      var valuesToEnable = {
        option1: [],
        option2: [],
        option3: [],
      };

      // Disable all options to start
      this.disableVariantGroup($(this.selectors.formContainer).find(".variant-input-wrap"));

      // Combine all available variants
      var availableVariants = this.variantsObject.filter(function (el) {
        if (variant.id === el.id) {
          return false;
        }

        // Option 1
        if (variant.option2 === el.option2 && variant.option3 === el.option3) {
          return true;
        }

        // Option 2
        if (variant.option1 === el.option1 && variant.option3 === el.option3) {
          return true;
        }

        // Option 3
        if (variant.option1 === el.option1 && variant.option2 === el.option2) {
          return true;
        }
      });

      // IE11 can't handle shortform of {variant} so extra step is needed
      var variantObject = {
        variant: variant,
      };

      availableVariants = Object.assign({}, variantObject, availableVariants);

      // Loop through each available variant to gather variant values
      for (var property in availableVariants) {
        if (availableVariants.hasOwnProperty(property)) {
          var item = availableVariants[property];
          var option1 = item.option1;
          var option2 = item.option2;
          var option3 = item.option3;

          if (option1) {
            if (valuesToEnable.option1.indexOf(option1) === -1) {
              valuesToEnable.option1.push(option1);
            }
          }
          if (option2) {
            if (valuesToEnable.option2.indexOf(option2) === -1) {
              valuesToEnable.option2.push(option2);
            }
          }
          if (option3) {
            if (valuesToEnable.option3.indexOf(option3) === -1) {
              valuesToEnable.option3.push(option3);
            }
          }
        }
      }

      // Have values to enable, separated by option index
      if (valuesToEnable.option1.length) {
        this.enableVariantOptionByValue(valuesToEnable.option1, "option1");
      }
      if (valuesToEnable.option2.length) {
        this.enableVariantOptionByValue(valuesToEnable.option2, "option2");
      }
      if (valuesToEnable.option3.length) {
        this.enableVariantOptionByValue(valuesToEnable.option3, "option3");
      }
    },

    updateVariantAvailability: function (evt, value, index) {
      if (value && index) {
        var newVal = value;
        var optionIndex = index;
      } else {
        var $el = $(evt.currentTarget);
        var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
        var optionIndex = $el.data("index");
      }

      var variants = this.variantsObject.filter(function (el) {
        return el[optionIndex] === newVal;
      });

      // Disable all buttons/dropdown options that aren't the current index
      $(this.selectors.formContainer)
        .find(".variant-input-wrap")
        .each(
          function (index, el) {
            var $group = $(el);
            var currentOptionIndex = $group.data("index");

            if (currentOptionIndex !== optionIndex) {
              // Disable all options as a starting point
              this.disableVariantGroup($group);

              // Loop through legit available options and enable
              for (var i = 0; i < variants.length; i++) {
                this.enableVariantOption($group, variants[i][currentOptionIndex]);
              }
            }
          }.bind(this)
        );
    },

    disableVariantGroup: function ($group) {
      if (theme.settings.dynamicVariantType === "dropdown") {
        $group.find("option").prop("disabled", true);
      } else {
        $group.find("input").prop("disabled", true);
        $group.find("label").toggleClass("disabled", true);
      }
    },

    enableVariantOptionByValue: function (array, index) {
      var $group = $(this.selectors.formContainer).find(
        '.variant-input-wrap[data-index="' + index + '"]'
      );

      for (var i = 0; i < array.length; i++) {
        this.enableVariantOption($group, array[i]);
      }
    },

    enableVariantOption: function ($group, value) {
      // Selecting by value so escape it
      value = value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");

      if (theme.settings.dynamicVariantType === "dropdown") {
        $group.find('option[value="' + value + '"]').prop("disabled", false);
      } else {
        var $buttonGroup = $group.find('.variant-input[data-value="' + value + '"]');
        $buttonGroup.find("input").prop("disabled", false);
        $buttonGroup.find("label").toggleClass("disabled", false);
      }
    },

    /*============================================================================
        Variant change methods
      ==============================================================================*/
    updateColorName: function (color, index) {
      // Updates on radio button change, not variant.js
      $("#VariantColorLabel-" + this.sectionId + "-" + index).text(color);
    },

    updateCartButton: function (evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          // Available, enable the submit button and change text
          $(this.selectors.addToCart).removeClass(classes.disabled).prop("disabled", false);
          var defaultText = $(this.selectors.addToCartText).data("default-text");
          $(this.selectors.addToCartText).html(defaultText);
        } else {
          // Sold out, disable the submit button and change text
          $(this.selectors.addToCart).addClass(classes.disabled).prop("disabled", true);
          $(this.selectors.addToCartText).html(theme.strings.soldOut);
        }
      } else {
        // The variant doesn't exist, disable submit button
        $(this.selectors.addToCart).addClass(classes.disabled).prop("disabled", true);
        $(this.selectors.addToCartText).html(theme.strings.unavailable);
      }
    },

    updatePrice: function (evt) {
      var variant = evt.variant;

      if (variant) {
        // Regular price
        $(this.selectors.price)
          .html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat))
          .show();

        // Sale price, if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice).html(
            theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat)
          );
          $(this.selectors.priceWrapper).removeClass("hide");
          $(this.selectors.price).addClass(classes.onSale);
          $(this.selectors.comparePriceA11y).attr("aria-hidden", "false");
          $(this.selectors.priceA11y).attr("aria-hidden", "false");

          var savings = variant.compare_at_price - variant.price;

          if (theme.settings.saveType == "percent") {
            savings = Math.round((savings * 100) / variant.compare_at_price) + "%";
          } else {
            savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          }

          $(this.selectors.savePrice)
            .removeClass("hide")
            .html(theme.strings.savePrice.replace("[saved_amount]", savings));
        } else {
          $(this.selectors.priceWrapper).addClass("hide");
          $(this.selectors.price).removeClass(classes.onSale);
          $(this.selectors.comparePriceA11y).attr("aria-hidden", "true");
          $(this.selectors.priceA11y).attr("aria-hidden", "true");
          $(this.selectors.savePrice).addClass("hide");
        }
      }
    },

    updateUnitPrice: function (evt) {
      var variant = evt.variant;

      if (variant && variant.unit_price) {
        $(this.selectors.unitPrice).html(
          theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat)
        );
        $(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(variant));
        $(this.selectors.unitWrapper).removeClass("hide").removeClass(classes.visuallyHide);
      } else {
        $(this.selectors.unitWrapper).addClass(classes.visuallyHide);
      }
    },

    updateSku: function (evt) {
      var variant = evt.variant;
      var newSku = "";

      if (variant) {
        if (variant.sku) {
          newSku = variant.sku;
        }

        $(this.selectors.sku).html(newSku);
      }
    },

    updateInventory: function (evt) {
      var variant = evt.variant;

      // Hide stock if no inventory management or policy is continue
      if (!variant || !variant.inventory_management || variant.inventory_policy === "continue") {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(false);
        return;
      }

      if (
        variant.inventory_management === "shopify" &&
        window.inventories &&
        window.inventories[this.sectionId]
      ) {
        variantInventoryObject = window.inventories[this.sectionId][variant.id];
        var quantity = variantInventoryObject.quantity;
        var showInventory = true;
        var showIncomingInventory = false;

        if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
          showInventory = false;
        }

        this.toggleInventoryQuantity(showInventory, quantity);

        if (!showInventory && variantInventoryObject.incoming) {
          showIncomingInventory = true;
        }

        this.toggleIncomingInventory(
          showIncomingInventory,
          variant.available,
          variantInventoryObject.next_incoming_date
        );
      }
    },

    toggleInventoryQuantity: function (show, qty) {
      if (!this.settings.inventory) {
        show = false;
      }

      if (show) {
        $(this.selectors.inventory)
          .removeClass("hide")
          .text(theme.strings.stockLabel.replace("[count]", qty));
      } else {
        $(this.selectors.inventory).addClass("hide");
      }
    },

    toggleIncomingInventory: function (show, available, date) {
      if (!this.settings.incomingInventory) {
        show = false;
      }

      if (show) {
        var string = available
          ? theme.strings.willNotShipUntil.replace("[date]", date)
          : theme.strings.willBeInStockAfter.replace("[date]", date);

        if (!date) {
          string = theme.strings.waitingForStock;
        }

        $(this.selectors.incomingInventory).removeClass("hide").text(string);
      } else {
        $(this.selectors.incomingInventory).addClass("hide");
      }
    },
    /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
    openModalProduct: function () {
      var $formHolder = $(this.selectors.modalFormHolder);
      var url = $formHolder.data("url");
      var template = $formHolder.data("template");

      // If no alt template, use stripped down ajax version
      if (!template) {
        url = url + "?view=ajax";
      }

      $formHolder.load(
        url + " #AddToCartForm-" + this.sectionId,
        function () {
          $formHolder.addClass("is-active");
          this.formSetup();
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }.bind(this)
      );
    },
  });

  return DrawerQuickAddProduct;
})();

class RecommendationsDrawer extends HTMLElement {
  constructor() {
    super();

    this.$container = this.querySelector("#Recommendations-product-recommendations-drawer");
    this.sectionId = this.$container.getAttribute("data-section-id");
    this.url = this.$container.getAttribute("data-url");

    this.selectors = {
      recommendations: "#Recommendations-product-recommendations-drawer",
      placeholder: ".product-recommendations-placeholder",
      sectionClass: ".product-recommendations",
      productResults: ".grid-product",
    };

    this.init();
  }

  async init() {
    var $section = this.querySelector(this.selectors.recommendations);

    if (!$section || $section.dataset.enable === "false") {
      return;
    }

    var $placeholder = $section.querySelector(this.selectors.placeholder);
    var id = $section.dataset.productId;
    var limit = $section.dataset.limit;

    if (id == "") {
      var cartData = await theme.cart.getCart();
      var firstItem = cartData.items && cartData.items[0];
      id = firstItem["product_id"];
    }

    var url =
      this.url + "?section_id=recommendations_cart_drawer&limit=" + limit + "&product_id=" + id;

    // Insert new data
    var response = await fetch(url);

    var tmpl = document.createElement("template");
    var resptext = await response.text();
    tmpl.innerHTML = resptext;

    var el = tmpl.content.querySelector("product-recommendations-drawer");
    var gridItems = el?.querySelectorAll(".product-recommendations .grid-product__title");

    if (el && el.hasChildNodes() && this.$container) {
      this.$container.outerHTML = el.innerHTML;
    }

    // this.loadPlaceholder(url + this.selectors.sectionClass, $placeholder, this.selectors, $section);

    // Hide section
    if (!gridItems || gridItems.length == 0) {
      this.classList.add("hide");
    } else {
      // Update upsell product
      this.updateUpsellProduct();
    }
  }

  loadPlaceholder(url, placeholder, selectors, section) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var data = xhr.responseText;
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, "text/html");
        var newDoc = doc.querySelector(selectors.sectionClass);

        theme.reinitProductGridItem(section);
        this.updateVariantInventory(section);
        // If no results, hide the entire section
        if (!newDoc.querySelector(selectors.productResults)) {
          section.classList.add("hide");
        } else {
          placeholder.classList.add("hide");
        }
      }
    }.bind(this);
    xhr.send();
  }

  updateUpsellProduct() {
    new theme.DrawerQuickAddProduct(
      $("#Recommendations-product-recommendations-drawer .quick-add__form")
    );
  }

  // Recommended products load via JS and don't add variant inventory to the
  // global variable that we later check. This function scrapes a data div
  // to get that info and manually add the values.
  updateVariantInventory(section) {
    window.inventories = window.inventories || {};
    section.querySelectorAll(".js-product-inventory-data").forEach(function (el) {
      var sectionId = "product-recommendations-drawer";
      window.inventories[sectionId] = {};
      el.querySelectorAll(".js-variant-inventory-data").forEach(function (child) {
        window.inventories[sectionId][child.dataset.id] = {
          quantity: child.dataset.quantity,
          incoming: child.dataset.incoming,
          next_incoming_date: child.dataset.date,
        };
      });
    });
  }
}

if (!customElements.get("product-recommendations-drawer")) {
  customElements.define("product-recommendations-drawer", RecommendationsDrawer);
}
